import { useQueryClient } from "@tanstack/react-query";
import { RequiringActionControllerApi } from "../../../services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "../../../utils/utils";

/**
 * @author [Rajkumar Rathod]
 */
interface Params {
  requiringActionId: string;
  xTENANTID?: string;
}

/**
 *
 * @returns useMutationWithLoading
 *
 * @author [Rajkumar Rathod]
 */
export const useResolveRequiringAction = () => {
  const queryClient = useQueryClient();
  return useMutationWithLoading(
    async (params: Params) =>
      new RequiringActionControllerApi(getConfigObject()).updateRequiringAction(
        params?.requiringActionId,
        getXtenantId()
      ),
    {
      // Resolving an action removes a row from "Requiring Actions" and
      // typically adds a counterpart entry to "Chronological Events" —
      // invalidate both Timeline cards so they refresh in place.
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["requiring-action"] });
        queryClient.invalidateQueries({ queryKey: ["chronological-record"] });
      },
    }
  );
};
